module.exports = __webpack_public_path__ + "img/GAME_BUTTERFLY.ae9610d4.png";